/* Preserve editor-backed presentation changes after the Ploy islands mount. */
(() => {
  const roots = document.querySelectorAll('[data-ploy-page="science"], [data-ploy-page="men"], [data-ploy-page="our-story"]');
  for (const root of roots) {
    function enhance() {
      const headings = [...root.querySelectorAll('[data-ploy-heading]')];
      if (root.dataset.ployPage === 'science') {
        const heading = headings.find(el => el.textContent.includes('The thinking behind our formulas'));
        const section = heading?.closest('section');
        const template = document.querySelector('#koppa-philosophy-media');
        if (section && template && !section.querySelector('video')) {
          const image = section.querySelector('img');
          if (image) { const media = template.content.cloneNode(true); media.querySelector('video')?.classList.add('koppa-philosophy-video'); image.replaceWith(media); }
        }
        if (section && !section.querySelector('.koppa-science-philosophy-cta')) {
          const copy = section.querySelector('.science-formula-copy') || heading.parentElement;
          const link = document.createElement('a');
          link.className = 'koppa-science-philosophy-cta';
          link.href = template?.dataset.href || '/pages/about';
          link.textContent = template?.dataset.label || 'Discover our philosophy';
          copy.append(link);
        }
      }
      if (root.dataset.ployPage === 'men') {
        const section = headings.find(el => el.textContent.includes('Built for better skin'))?.closest('section');
        const image = section?.querySelector('img');
        if (image && !image.hasAttribute('data-koppa-men-protocol-image')) {
          image.parentElement.classList.add('koppa-men-protocol-media');
          image.setAttribute('data-koppa-men-protocol-image', '');
          image.removeAttribute('srcset');
          image.src = 'https://cdn.shopify.com/s/files/1/0774/8691/5772/files/koppa-ghk-cu-protocol-hero.png?width=1800';
        }
      }
      if (root.dataset.ployPage === 'our-story') {
        const caption = [...root.querySelectorAll('p')].find(el => el.textContent.includes('Chantelle and Madelaine (2002)') && !el.classList.contains('koppa-story-photo-caption'));
        if (caption) {
          const text = caption.textContent;
          const bar = caption.closest('section');
          const hero = root.querySelector('.hero');
          if (bar && bar !== hero && !bar.contains(hero)) {
            for (const [selector, mobile] of [['.hero__media', false], ['.hero__copy', true]]) {
              const target = root.querySelector(selector);
              if (target && !target.querySelector('.koppa-story-photo-caption')) {
                const label = document.createElement('p');
                label.className = 'koppa-story-photo-caption' + (mobile ? ' koppa-story-photo-caption--mobile' : '');
                label.textContent = text; target.append(label);
              }
            }
            bar.remove();
          }
        }
      }
    }
    enhance();
    new MutationObserver(enhance).observe(root, {childList: true, subtree: true});
  }
})();
